import { render } from "./JSONExport.vue?vue&type=template&id=1ddfe7fb"
import script from "./JSONExport.vue?vue&type=script&lang=js"
export * from "./JSONExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__